/**
 * @generated SignedSource<<fc38c597742ed92c8418433e0f8ebd0a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type SkillsAllTargetSkillTypesQuery$variables = Record<PropertyKey, never>;
export type SkillsAllTargetSkillTypesQuery$data = {
  readonly allTargetSkillTypes: ReadonlyArray<{
    readonly id: string;
    readonly isActive: boolean;
    readonly name: string | null | undefined;
  }>;
};
export type SkillsAllTargetSkillTypesQuery = {
  response: SkillsAllTargetSkillTypesQuery$data;
  variables: SkillsAllTargetSkillTypesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "TargetSkillTypeNode",
    "kind": "LinkedField",
    "name": "allTargetSkillTypes",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isActive",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SkillsAllTargetSkillTypesQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SkillsAllTargetSkillTypesQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "db88aee1057b5e37ec6ba9ef0fba3079",
    "id": null,
    "metadata": {},
    "name": "SkillsAllTargetSkillTypesQuery",
    "operationKind": "query",
    "text": "query SkillsAllTargetSkillTypesQuery {\n  allTargetSkillTypes {\n    id\n    name\n    isActive\n  }\n}\n"
  }
};
})();

(node as any).hash = "755024b45677c473fff244eec5c2e5c2";

export default node;
